module.exports = __webpack_public_path__ + "static/media/udeNobashi.68534337.png";